import * as helper from './helper';

export function initImprint(impressumLink: Element, datenschutzLink: Element) {
	const blocker = helper.$('#blocker');
	const closer = blocker.querySelector('#imprintCloser');
	const impressum = helper.$('#impressum');
	const datenschutz = helper.$('#datenschutz');

	helper.addClickListener(closer, (e:MouseEvent) => {
		e.preventDefault();
		helper.hide(blocker);
	})

	helper.addClickListener(impressumLink, (e:MouseEvent) => {
		e.preventDefault();
		helper.show(blocker);
		helper.show(impressum);
		helper.hide(datenschutz);
	})

	helper.addClickListener(datenschutzLink, (e:MouseEvent) => {
		e.preventDefault();
		helper.show(blocker);
		helper.show(datenschutz);
		helper.hide(impressum);
	})
}
